/**
 * Raven监控
 * @author luoying
 * @since 17/08/11
 */
import Raven from 'raven-js';
const root = window;
const RPCONFIG = root.RPCONFIG || {};
export function context(func, ...args) {
    Raven.context(func, ...args);
}
export function install(dsn) {
    if (process.env.NODE_ENV !== 'development') {
        Raven.config(dsn, {
            // 项目当前运行环境：dev | test | prod
            environment: RPCONFIG.RUNTIME_ENV || 'unknown',
            release: process.env.RELEASE,
            tags: {
                // node运行时: development | production
                node_env: process.env.NODE_ENV || '',
                git_commit: process.env.GIT_COMMIT_HASH || '',
            },
        }).install();
    }
    return Raven;
}
//# sourceMappingURL=raven.js.map